var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { ViewLayoutStatus } from '../../models/view-layout-status.enum';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ViewToolsMode } from '../../models/view-tools-mode.enum';
import { ViewActions } from '../../state/view.actions';
import { ViewBreakpoint } from '../../models/view-breakpoint.enum';
import { ViewLayout } from '../../models/view-layout.enum';
import { LayoutService } from '../../layout.service';
var ViewToolbarComponent = /** @class */ (function () {
    // ---------- Lifecycle hooks ----------
    function ViewToolbarComponent(store, changeDetectorRef, layoutService) {
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.layoutService = layoutService;
        // ---------- Input / Output ----------
        this.canExit = true;
        this.mode = ViewToolsMode.Main;
        this.lockMode = false;
        // ---------- Class Variables ----------
        this.ngUnsubscribe = new Subject();
        this.viewBreakpoint = ViewBreakpoint;
        this.viewToolsMode = ViewToolsMode;
        this.viewLayout = ViewLayout;
    }
    ViewToolbarComponent.prototype.ngOnInit = function () {
        this.initLayoutListener();
    };
    ViewToolbarComponent.prototype.initLayoutListener = function () {
        var _this = this;
        this.store.select(ViewState.getLayout)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            if (_this.lockMode) {
                return;
            }
            _this.mode = ViewToolsMode.Main;
            if (_this.layoutService.isLayoutVisible(ViewLayout.Media)) {
                _this.mode = ViewToolsMode.Media;
            }
            if (_this.layoutService.isToolsVisible()) {
                _this.mode = ViewToolsMode.Tools;
            }
            _this.changeDetectorRef.markForCheck();
        });
    };
    // ---------- Interactions ----------
    ViewToolbarComponent.prototype.handleExitClick = function () {
        var layout = this.store.selectSnapshot(ViewState.getLayout);
        layout.media.status = ViewLayoutStatus.Hide;
        layout.tools.status = ViewLayoutStatus.Hide;
        this.store.dispatch(new ViewActions.SetLayout(layout));
    };
    __decorate([
        Select(ViewState.getBreakpoint),
        __metadata("design:type", Observable)
    ], ViewToolbarComponent.prototype, "breakpoint$", void 0);
    return ViewToolbarComponent;
}());
export { ViewToolbarComponent };
